const LANG_KEY = 'pinweelo-lang'
const RTL = new Set(['ar', 'he'])

export const LANG_CODES = ['en', 'ru', 'fr', 'sp', 'ar', 'de', 'it', 'pt', 'zh', 'ja', 'ko', 'hi', 'tr', 'nl', 'he', 'pl', 'sv', 'uk', 'id', 'th']

const en = {
  history: 'History',
  longs: 'Longs',
  images: 'Photos',
  shorts: 'Shorts',
  movies: 'Music',
  all: 'All',
  home: 'Home',
  notifications: 'Alerts',
  shotavideo: 'Create',
  settings: 'Settings',
  watch: 'Watch',
  search: 'Search',
  web: 'Web',
  email: 'Email',
  job: 'Job',
  hobby: 'Hobby',
  bio: 'Bio',
  following: 'Following',
  postion: 'Country',
  thereisnofriends: 'No following yet',
  thereisnofollowers: 'No followers yet',
  thereisnovideos: 'No videos yet',
  thereisnophotos: 'No photos yet',
  thereisnoshorts: 'No shorts yet',
  thereisnohistory: 'No history yet',
  thereisnoresults: 'No results yet',
  thereisnoweb: 'No web results',
  thereisnopeople: 'No people found',
  thereisnotags: 'No tags found',
  thereisnoimages: 'No images found',
  thereisnonotifications: 'No notifications yet',
  thereisnomessages: 'No messages yet',
  friends: 'Friends',
  vist: 'Visit',
  chat: 'Chat',
  remove: 'Remove',
  searchHere: 'Search here',
  messages: 'Messages',
  go: 'Go',
  delete: 'Delete',
  hint: 'Hint',
  from: 'From',
  date: 'Date',
  comments: 'Comments',
  share: 'Share',
  report: 'Report',
  follow: 'Follow',
  followers: 'Followers',
  age: 'Age',
  discription: 'Description',
  unfollow: 'Unfollow',
  profile: 'Profile',
  preferences: 'Preferences',
  language: 'Language',
  country: 'Country',
  cardId: 'Card ID',
  security: 'Security',
  password: 'Password',
  saveChanges: 'Save changes',
  logout: 'Log out',
  displayName: 'Display name',
  birthday: 'Birthday',
  addPhoto: 'Add photo',
  changePhoto: 'Change photo',
  like: 'Like',
  dislike: 'Dislike',
  save: 'Save',
  subscribe: 'Subscribe',
  subscribed: 'Subscribed',
  rooms: 'Rooms',
  explore: 'Explore',
  pickBirthday: 'Pick your birthday'
}

const ru = {
  ...en,
  history: 'История',
  longs: 'Длинные',
  images: 'Фото',
  shorts: 'Короткие',
  movies: 'Музыка',
  all: 'Все',
  home: 'Главная',
  notifications: 'Уведомления',
  shotavideo: 'Создать',
  settings: 'Настройки',
  watch: 'Смотреть',
  search: 'Поиск',
  email: 'Почта',
  job: 'Работа',
  hobby: 'Хобби',
  bio: 'О себе',
  following: 'Подписки',
  postion: 'Страна',
  thereisnofriends: 'Пока нет подписок',
  thereisnofollowers: 'Пока нет подписчиков',
  thereisnovideos: 'Пока нет видео',
  thereisnophotos: 'Пока нет фото',
  thereisnoshorts: 'Пока нет коротких',
  thereisnohistory: 'Пока нет истории',
  thereisnoresults: 'Пока нет результатов',
  thereisnopeople: 'Люди не найдены',
  thereisnotags: 'Теги не найдены',
  thereisnoimages: 'Фото не найдены',
  thereisnonotifications: 'Пока нет уведомлений',
  thereisnomessages: 'Пока нет сообщений',
  friends: 'Друзья',
  vist: 'Открыть',
  chat: 'Чат',
  remove: 'Удалить',
  searchHere: 'Искать здесь',
  messages: 'Сообщения',
  go: 'Перейти',
  delete: 'Удалить',
  hint: 'Подсказка',
  from: 'От',
  date: 'Дата',
  comments: 'Комментарии',
  share: 'Поделиться',
  report: 'Пожаловаться',
  follow: 'Подписаться',
  followers: 'Подписчики',
  age: 'Возраст',
  discription: 'Описание',
  unfollow: 'Отписаться',
  profile: 'Профиль',
  preferences: 'Параметры',
  language: 'Язык',
  country: 'Страна',
  cardId: 'ID карты',
  security: 'Безопасность',
  password: 'Пароль',
  saveChanges: 'Сохранить',
  logout: 'Выйти',
  displayName: 'Имя',
  birthday: 'День рождения',
  addPhoto: 'Добавить фото',
  changePhoto: 'Сменить фото',
  like: 'Нравится',
  dislike: 'Не нравится',
  save: 'Сохранить',
  subscribe: 'Подписка',
  subscribed: 'Вы подписаны',
  rooms: 'Комнаты',
  explore: 'Обзор',
  pickBirthday: 'Выберите дату рождения'
}

const fr = {
  ...en,
  history: 'Historique',
  longs: 'Longs',
  images: 'Photos',
  shorts: 'Shorts',
  movies: 'Musique',
  all: 'Tout',
  home: 'Accueil',
  notifications: 'Alertes',
  shotavideo: 'Créer',
  settings: 'Réglages',
  watch: 'Regarder',
  search: 'Recherche',
  email: 'E-mail',
  job: 'Métier',
  hobby: 'Loisirs',
  bio: 'Bio',
  following: 'Abonnements',
  postion: 'Pays',
  thereisnofriends: 'Pas encore d’abonnements',
  thereisnofollowers: 'Pas encore d’abonnés',
  thereisnovideos: 'Pas encore de vidéos',
  thereisnophotos: 'Pas encore de photos',
  thereisnoshorts: 'Pas encore de shorts',
  thereisnohistory: 'Pas encore d’historique',
  thereisnoresults: 'Aucun résultat',
  thereisnopeople: 'Personne introuvable',
  thereisnotags: 'Aucun tag',
  thereisnoimages: 'Aucune photo',
  thereisnonotifications: 'Pas encore de notifications',
  thereisnomessages: 'Pas encore de messages',
  friends: 'Amis',
  vist: 'Voir',
  chat: 'Chat',
  remove: 'Retirer',
  searchHere: 'Rechercher ici',
  messages: 'Messages',
  go: 'Aller',
  delete: 'Supprimer',
  hint: 'Indice',
  from: 'De',
  date: 'Date',
  comments: 'Commentaires',
  share: 'Partager',
  report: 'Signaler',
  follow: 'Suivre',
  followers: 'Abonnés',
  age: 'Âge',
  discription: 'Description',
  unfollow: 'Se désabonner',
  profile: 'Profil',
  preferences: 'Préférences',
  language: 'Langue',
  country: 'Pays',
  cardId: 'ID carte',
  security: 'Sécurité',
  password: 'Mot de passe',
  saveChanges: 'Enregistrer',
  logout: 'Déconnexion',
  displayName: 'Nom affiché',
  birthday: 'Anniversaire',
  addPhoto: 'Ajouter une photo',
  changePhoto: 'Changer la photo',
  like: 'J’aime',
  dislike: 'Je n’aime pas',
  save: 'Enregistrer',
  subscribe: 'S’abonner',
  subscribed: 'Abonné',
  rooms: 'Salons',
  explore: 'Explorer',
  pickBirthday: 'Choisissez votre anniversaire'
}

const sp = {
  ...en,
  history: 'Historial',
  longs: 'Largos',
  images: 'Fotos',
  shorts: 'Shorts',
  movies: 'Música',
  all: 'Todo',
  home: 'Inicio',
  notifications: 'Alertas',
  shotavideo: 'Crear',
  settings: 'Ajustes',
  watch: 'Ver',
  search: 'Buscar',
  email: 'Correo',
  job: 'Trabajo',
  hobby: 'Pasatiempo',
  bio: 'Bio',
  following: 'Siguiendo',
  postion: 'País',
  thereisnofriends: 'Aún no sigues a nadie',
  thereisnofollowers: 'Aún no hay seguidores',
  thereisnovideos: 'Aún no hay videos',
  thereisnophotos: 'Aún no hay fotos',
  thereisnoshorts: 'Aún no hay shorts',
  thereisnohistory: 'Aún no hay historial',
  thereisnoresults: 'Sin resultados',
  thereisnopeople: 'No se encontraron personas',
  thereisnotags: 'No hay etiquetas',
  thereisnoimages: 'No hay fotos',
  thereisnonotifications: 'Aún no hay notificaciones',
  thereisnomessages: 'Aún no hay mensajes',
  friends: 'Amigos',
  vist: 'Visitar',
  chat: 'Chat',
  remove: 'Quitar',
  searchHere: 'Buscar aquí',
  messages: 'Mensajes',
  go: 'Ir',
  delete: 'Eliminar',
  hint: 'Nota',
  from: 'De',
  date: 'Fecha',
  comments: 'Comentarios',
  share: 'Compartir',
  report: 'Reportar',
  follow: 'Seguir',
  followers: 'Seguidores',
  age: 'Edad',
  discription: 'Descripción',
  unfollow: 'Dejar de seguir',
  profile: 'Perfil',
  preferences: 'Preferencias',
  language: 'Idioma',
  country: 'País',
  cardId: 'ID de tarjeta',
  security: 'Seguridad',
  password: 'Contraseña',
  saveChanges: 'Guardar cambios',
  logout: 'Cerrar sesión',
  displayName: 'Nombre',
  birthday: 'Cumpleaños',
  addPhoto: 'Añadir foto',
  changePhoto: 'Cambiar foto',
  like: 'Me gusta',
  dislike: 'No me gusta',
  save: 'Guardar',
  subscribe: 'Suscribirse',
  subscribed: 'Suscrito',
  rooms: 'Salas',
  explore: 'Explorar',
  pickBirthday: 'Elige tu cumpleaños'
}

const ar = {
  ...en,
  history: 'السجل',
  longs: 'طويلة',
  images: 'صور',
  shorts: 'قصيرة',
  movies: 'موسيقى',
  all: 'الكل',
  home: 'الرئيسية',
  notifications: 'التنبيهات',
  shotavideo: 'إنشاء',
  settings: 'الإعدادات',
  watch: 'مشاهدة',
  search: 'بحث',
  email: 'البريد',
  job: 'العمل',
  hobby: 'الهواية',
  bio: 'نبذة',
  following: 'المتابَعون',
  postion: 'البلد',
  thereisnofriends: 'لا توجد متابعات بعد',
  thereisnofollowers: 'لا يوجد متابعون بعد',
  thereisnovideos: 'لا توجد فيديوهات بعد',
  thereisnophotos: 'لا توجد صور بعد',
  thereisnoshorts: 'لا توجد قصص قصيرة بعد',
  thereisnohistory: 'لا يوجد سجل بعد',
  thereisnoresults: 'لا نتائج',
  thereisnopeople: 'لم يتم العثور على أشخاص',
  thereisnotags: 'لا توجد وسوم',
  thereisnoimages: 'لا توجد صور',
  thereisnonotifications: 'لا توجد إشعارات بعد',
  thereisnomessages: 'لا توجد رسائل بعد',
  friends: 'الأصدقاء',
  vist: 'زيارة',
  chat: 'محادثة',
  remove: 'إزالة',
  searchHere: 'ابحث هنا',
  messages: 'الرسائل',
  go: 'اذهب',
  delete: 'حذف',
  hint: 'تلميح',
  from: 'من',
  date: 'التاريخ',
  comments: 'التعليقات',
  share: 'مشاركة',
  report: 'إبلاغ',
  follow: 'متابعة',
  followers: 'المتابعون',
  age: 'العمر',
  discription: 'الوصف',
  unfollow: 'إلغاء المتابعة',
  profile: 'الملف',
  preferences: 'التفضيلات',
  language: 'اللغة',
  country: 'البلد',
  cardId: 'رقم البطاقة',
  security: 'الأمان',
  password: 'كلمة المرور',
  saveChanges: 'حفظ التغييرات',
  logout: 'تسجيل الخروج',
  displayName: 'الاسم الظاهر',
  birthday: 'تاريخ الميلاد',
  addPhoto: 'إضافة صورة',
  changePhoto: 'تغيير الصورة',
  like: 'إعجاب',
  dislike: 'غير معجب',
  save: 'حفظ',
  subscribe: 'اشترك',
  subscribed: 'مشترك',
  rooms: 'الغرف',
  explore: 'استكشاف',
  pickBirthday: 'اختر تاريخ ميلادك'
}

const de = {
  ...en,
  history: 'Verlauf',
  longs: 'Lange',
  images: 'Fotos',
  shorts: 'Shorts',
  movies: 'Musik',
  all: 'Alle',
  home: 'Start',
  notifications: 'Hinweise',
  shotavideo: 'Erstellen',
  settings: 'Einstellungen',
  watch: 'Ansehen',
  search: 'Suche',
  email: 'E-Mail',
  job: 'Beruf',
  hobby: 'Hobby',
  bio: 'Bio',
  following: 'Folge ich',
  postion: 'Land',
  thereisnofriends: 'Noch keine Folge-Konten',
  thereisnofollowers: 'Noch keine Follower',
  thereisnovideos: 'Noch keine Videos',
  thereisnophotos: 'Noch keine Fotos',
  thereisnoshorts: 'Noch keine Shorts',
  thereisnohistory: 'Noch kein Verlauf',
  thereisnoresults: 'Keine Ergebnisse',
  thereisnopeople: 'Keine Personen gefunden',
  thereisnotags: 'Keine Tags',
  thereisnoimages: 'Keine Fotos',
  thereisnonotifications: 'Noch keine Benachrichtigungen',
  thereisnomessages: 'Noch keine Nachrichten',
  friends: 'Freunde',
  vist: 'Besuchen',
  chat: 'Chat',
  remove: 'Entfernen',
  searchHere: 'Hier suchen',
  messages: 'Nachrichten',
  go: 'Los',
  delete: 'Löschen',
  hint: 'Hinweis',
  from: 'Von',
  date: 'Datum',
  comments: 'Kommentare',
  share: 'Teilen',
  report: 'Melden',
  follow: 'Folgen',
  followers: 'Follower',
  age: 'Alter',
  discription: 'Beschreibung',
  unfollow: 'Entfolgen',
  profile: 'Profil',
  preferences: 'Einstellungen',
  language: 'Sprache',
  country: 'Land',
  cardId: 'Karten-ID',
  security: 'Sicherheit',
  password: 'Passwort',
  saveChanges: 'Speichern',
  logout: 'Abmelden',
  displayName: 'Anzeigename',
  birthday: 'Geburtstag',
  addPhoto: 'Foto hinzufügen',
  changePhoto: 'Foto ändern',
  like: 'Gefällt mir',
  dislike: 'Gefällt mir nicht',
  save: 'Speichern',
  subscribe: 'Abonnieren',
  subscribed: 'Abonniert',
  rooms: 'Räume',
  explore: 'Entdecken',
  pickBirthday: 'Geburtstag wählen'
}

const it = {
  ...en,
  history: 'Cronologia',
  longs: 'Lunghi',
  images: 'Foto',
  shorts: 'Short',
  movies: 'Musica',
  all: 'Tutti',
  home: 'Home',
  notifications: 'Avvisi',
  shotavideo: 'Crea',
  settings: 'Impostazioni',
  watch: 'Guarda',
  search: 'Cerca',
  email: 'Email',
  job: 'Lavoro',
  hobby: 'Hobby',
  bio: 'Bio',
  following: 'Seguiti',
  postion: 'Paese',
  thereisnofriends: 'Non segui ancora nessuno',
  thereisnofollowers: 'Nessun follower ancora',
  thereisnovideos: 'Nessun video ancora',
  thereisnophotos: 'Nessuna foto ancora',
  thereisnoshorts: 'Nessuno short ancora',
  thereisnohistory: 'Nessuna cronologia',
  thereisnoresults: 'Nessun risultato',
  thereisnopeople: 'Nessuna persona trovata',
  thereisnotags: 'Nessun tag',
  thereisnoimages: 'Nessuna foto',
  thereisnonotifications: 'Nessuna notifica',
  thereisnomessages: 'Nessun messaggio',
  friends: 'Amici',
  vist: 'Visita',
  chat: 'Chat',
  remove: 'Rimuovi',
  searchHere: 'Cerca qui',
  messages: 'Messaggi',
  go: 'Vai',
  delete: 'Elimina',
  hint: 'Suggerimento',
  from: 'Da',
  date: 'Data',
  comments: 'Commenti',
  share: 'Condividi',
  report: 'Segnala',
  follow: 'Segui',
  followers: 'Follower',
  age: 'Età',
  discription: 'Descrizione',
  unfollow: 'Non seguire',
  profile: 'Profilo',
  preferences: 'Preferenze',
  language: 'Lingua',
  country: 'Paese',
  cardId: 'ID carta',
  security: 'Sicurezza',
  password: 'Password',
  saveChanges: 'Salva',
  logout: 'Esci',
  displayName: 'Nome visibile',
  birthday: 'Compleanno',
  addPhoto: 'Aggiungi foto',
  changePhoto: 'Cambia foto',
  like: 'Mi piace',
  dislike: 'Non mi piace',
  save: 'Salva',
  subscribe: 'Iscriviti',
  subscribed: 'Iscritto',
  rooms: 'Stanze',
  explore: 'Esplora',
  pickBirthday: 'Scegli il compleanno'
}

const pt = {
  ...en,
  history: 'Histórico',
  longs: 'Longos',
  images: 'Fotos',
  shorts: 'Shorts',
  movies: 'Música',
  all: 'Tudo',
  home: 'Início',
  notifications: 'Alertas',
  shotavideo: 'Criar',
  settings: 'Definições',
  watch: 'Ver',
  search: 'Pesquisar',
  email: 'E-mail',
  job: 'Trabalho',
  hobby: 'Hobby',
  bio: 'Bio',
  following: 'A seguir',
  postion: 'País',
  thereisnofriends: 'Ainda não segue ninguém',
  thereisnofollowers: 'Ainda sem seguidores',
  thereisnovideos: 'Ainda sem vídeos',
  thereisnophotos: 'Ainda sem fotos',
  thereisnoshorts: 'Ainda sem shorts',
  thereisnohistory: 'Ainda sem histórico',
  thereisnoresults: 'Sem resultados',
  thereisnopeople: 'Nenhuma pessoa encontrada',
  thereisnotags: 'Sem tags',
  thereisnoimages: 'Sem fotos',
  thereisnonotifications: 'Ainda sem notificações',
  thereisnomessages: 'Ainda sem mensagens',
  friends: 'Amigos',
  vist: 'Visitar',
  chat: 'Chat',
  remove: 'Remover',
  searchHere: 'Pesquisar aqui',
  messages: 'Mensagens',
  go: 'Ir',
  delete: 'Eliminar',
  hint: 'Dica',
  from: 'De',
  date: 'Data',
  comments: 'Comentários',
  share: 'Partilhar',
  report: 'Denunciar',
  follow: 'Seguir',
  followers: 'Seguidores',
  age: 'Idade',
  discription: 'Descrição',
  unfollow: 'Deixar de seguir',
  profile: 'Perfil',
  preferences: 'Preferências',
  language: 'Idioma',
  country: 'País',
  cardId: 'ID do cartão',
  security: 'Segurança',
  password: 'Palavra-passe',
  saveChanges: 'Guardar',
  logout: 'Sair',
  displayName: 'Nome',
  birthday: 'Aniversário',
  addPhoto: 'Adicionar foto',
  changePhoto: 'Mudar foto',
  like: 'Gosto',
  dislike: 'Não gosto',
  save: 'Guardar',
  subscribe: 'Subscrever',
  subscribed: 'Subscrito',
  rooms: 'Salas',
  explore: 'Explorar',
  pickBirthday: 'Escolha o aniversário'
}

const zh = {
  ...en,
  history: '历史',
  longs: '长视频',
  images: '图片',
  shorts: '短视频',
  movies: '音乐',
  all: '全部',
  home: '首页',
  notifications: '提醒',
  shotavideo: '创作',
  settings: '设置',
  watch: '观看',
  search: '搜索',
  email: '邮箱',
  job: '工作',
  hobby: '爱好',
  bio: '简介',
  following: '关注',
  postion: '国家',
  thereisnofriends: '还没有关注',
  thereisnofollowers: '还没有粉丝',
  thereisnovideos: '还没有视频',
  thereisnophotos: '还没有图片',
  thereisnoshorts: '还没有短视频',
  thereisnohistory: '还没有历史',
  thereisnoresults: '没有结果',
  thereisnopeople: '未找到用户',
  thereisnotags: '没有标签',
  thereisnoimages: '没有图片',
  thereisnonotifications: '还没有通知',
  thereisnomessages: '还没有消息',
  friends: '好友',
  vist: '查看',
  chat: '聊天',
  remove: '移除',
  searchHere: '在此搜索',
  messages: '消息',
  go: '前往',
  delete: '删除',
  hint: '提示',
  from: '来自',
  date: '日期',
  comments: '评论',
  share: '分享',
  report: '举报',
  follow: '关注',
  followers: '粉丝',
  age: '年龄',
  discription: '简介',
  unfollow: '取消关注',
  profile: '主页',
  preferences: '偏好',
  language: '语言',
  country: '国家',
  cardId: '卡号',
  security: '安全',
  password: '密码',
  saveChanges: '保存',
  logout: '退出',
  displayName: '显示名称',
  birthday: '生日',
  addPhoto: '添加照片',
  changePhoto: '更换照片',
  like: '喜欢',
  dislike: '不喜欢',
  save: '保存',
  subscribe: '订阅',
  subscribed: '已订阅',
  rooms: '房间',
  explore: '发现',
  pickBirthday: '选择生日'
}

const ja = {
  ...en,
  history: '履歴',
  longs: '長尺',
  images: '写真',
  shorts: 'ショート',
  movies: '音楽',
  all: 'すべて',
  home: 'ホーム',
  notifications: '通知',
  shotavideo: '作成',
  settings: '設定',
  watch: '視聴',
  search: '検索',
  email: 'メール',
  job: '仕事',
  hobby: '趣味',
  bio: '自己紹介',
  following: 'フォロー中',
  postion: '国',
  thereisnofriends: 'まだフォローしていません',
  thereisnofollowers: 'まだフォロワーがいません',
  thereisnovideos: '動画はまだありません',
  thereisnophotos: '写真はまだありません',
  thereisnoshorts: 'ショートはまだありません',
  thereisnohistory: '履歴はまだありません',
  thereisnoresults: '結果がありません',
  thereisnopeople: 'ユーザーが見つかりません',
  thereisnotags: 'タグがありません',
  thereisnoimages: '写真がありません',
  thereisnonotifications: '通知はまだありません',
  thereisnomessages: 'メッセージはまだありません',
  friends: '友だち',
  vist: '見る',
  chat: 'チャット',
  remove: '削除',
  searchHere: 'ここで検索',
  messages: 'メッセージ',
  go: '開く',
  delete: '削除',
  hint: 'ヒント',
  from: 'から',
  date: '日付',
  comments: 'コメント',
  share: '共有',
  report: '報告',
  follow: 'フォロー',
  followers: 'フォロワー',
  age: '年齢',
  discription: '説明',
  unfollow: 'フォロー解除',
  profile: 'プロフィール',
  preferences: '設定',
  language: '言語',
  country: '国',
  cardId: 'カードID',
  security: 'セキュリティ',
  password: 'パスワード',
  saveChanges: '保存',
  logout: 'ログアウト',
  displayName: '表示名',
  birthday: '誕生日',
  addPhoto: '写真を追加',
  changePhoto: '写真を変更',
  like: 'いいね',
  dislike: 'よくないね',
  save: '保存',
  subscribe: '登録',
  subscribed: '登録済み',
  rooms: 'ルーム',
  explore: '探す',
  pickBirthday: '誕生日を選ぶ'
}

const ko = {
  ...en,
  history: '기록',
  longs: '긴 영상',
  images: '사진',
  shorts: '쇼츠',
  movies: '음악',
  all: '전체',
  home: '홈',
  notifications: '알림',
  shotavideo: '만들기',
  settings: '설정',
  watch: '시청',
  search: '검색',
  email: '이메일',
  job: '직업',
  hobby: '취미',
  bio: '소개',
  following: '팔로잉',
  postion: '국가',
  thereisnofriends: '아직 팔로잉이 없습니다',
  thereisnofollowers: '아직 팔로워가 없습니다',
  thereisnovideos: '아직 영상이 없습니다',
  thereisnophotos: '아직 사진이 없습니다',
  thereisnoshorts: '아직 쇼츠가 없습니다',
  thereisnohistory: '아직 기록이 없습니다',
  thereisnoresults: '결과가 없습니다',
  thereisnopeople: '사용자를 찾을 수 없습니다',
  thereisnotags: '태그가 없습니다',
  thereisnoimages: '사진이 없습니다',
  thereisnonotifications: '아직 알림이 없습니다',
  thereisnomessages: '아직 메시지가 없습니다',
  friends: '친구',
  vist: '방문',
  chat: '채팅',
  remove: '삭제',
  searchHere: '여기서 검색',
  messages: '메시지',
  go: '이동',
  delete: '삭제',
  hint: '힌트',
  from: '보낸 사람',
  date: '날짜',
  comments: '댓글',
  share: '공유',
  report: '신고',
  follow: '팔로우',
  followers: '팔로워',
  age: '나이',
  discription: '설명',
  unfollow: '언팔로우',
  profile: '프로필',
  preferences: '환경설정',
  language: '언어',
  country: '국가',
  cardId: '카드 ID',
  security: '보안',
  password: '비밀번호',
  saveChanges: '저장',
  logout: '로그아웃',
  displayName: '표시 이름',
  birthday: '생일',
  addPhoto: '사진 추가',
  changePhoto: '사진 변경',
  like: '좋아요',
  dislike: '싫어요',
  save: '저장',
  subscribe: '구독',
  subscribed: '구독 중',
  rooms: '룸',
  explore: '탐색',
  pickBirthday: '생일을 선택하세요'
}

const hi = {
  ...en,
  history: 'इतिहास',
  longs: 'लंबे',
  images: 'फ़ोटो',
  shorts: 'शॉर्ट्स',
  movies: 'संगीत',
  all: 'सभी',
  home: 'होम',
  notifications: 'अलर्ट',
  shotavideo: 'बनाएँ',
  settings: 'सेटिंग्स',
  watch: 'देखें',
  search: 'खोजें',
  email: 'ईमेल',
  job: 'काम',
  hobby: 'शौक',
  bio: 'बायो',
  following: 'फ़ॉलोइंग',
  postion: 'देश',
  thereisnofriends: 'अभी कोई फ़ॉलो नहीं',
  thereisnofollowers: 'अभी कोई फ़ॉलोअर नहीं',
  thereisnovideos: 'अभी कोई वीडियो नहीं',
  thereisnophotos: 'अभी कोई फ़ोटो नहीं',
  thereisnoshorts: 'अभी कोई शॉर्ट नहीं',
  thereisnohistory: 'अभी कोई इतिहास नहीं',
  thereisnoresults: 'कोई परिणाम नहीं',
  thereisnopeople: 'कोई व्यक्ति नहीं मिला',
  thereisnotags: 'कोई टैग नहीं',
  thereisnoimages: 'कोई फ़ोटो नहीं',
  thereisnonotifications: 'अभी कोई सूचना नहीं',
  thereisnomessages: 'अभी कोई संदेश नहीं',
  friends: 'दोस्त',
  vist: 'देखें',
  chat: 'चैट',
  remove: 'हटाएँ',
  searchHere: 'यहाँ खोजें',
  messages: 'संदेश',
  go: 'जाएँ',
  delete: 'हटाएँ',
  hint: 'संकेत',
  from: 'से',
  date: 'तारीख',
  comments: 'टिप्पणियाँ',
  share: 'शेयर',
  report: 'रिपोर्ट',
  follow: 'फ़ॉलो',
  followers: 'फ़ॉलोअर',
  age: 'उम्र',
  discription: 'विवरण',
  unfollow: 'अनफ़ॉलो',
  profile: 'प्रोफ़ाइल',
  preferences: 'पसंद',
  language: 'भाषा',
  country: 'देश',
  cardId: 'कार्ड आईडी',
  security: 'सुरक्षा',
  password: 'पासवर्ड',
  saveChanges: 'सेव करें',
  logout: 'लॉग आउट',
  displayName: 'नाम',
  birthday: 'जन्मदिन',
  addPhoto: 'फ़ोटो जोड़ें',
  changePhoto: 'फ़ोटो बदलें',
  like: 'पसंद',
  dislike: 'नापसंद',
  save: 'सेव',
  subscribe: 'सब्सक्राइब',
  subscribed: 'सब्सक्राइब किया',
  rooms: 'रूम',
  explore: 'एक्सप्लोर',
  pickBirthday: 'जन्मदिन चुनें'
}

const tr = {
  ...en,
  history: 'Geçmiş',
  longs: 'Uzun',
  images: 'Fotoğraflar',
  shorts: 'Shorts',
  movies: 'Müzik',
  all: 'Tümü',
  home: 'Ana sayfa',
  notifications: 'Uyarılar',
  shotavideo: 'Oluştur',
  settings: 'Ayarlar',
  watch: 'İzle',
  search: 'Ara',
  email: 'E-posta',
  job: 'İş',
  hobby: 'Hobi',
  bio: 'Biyografi',
  following: 'Takip',
  postion: 'Ülke',
  thereisnofriends: 'Henüz takip yok',
  thereisnofollowers: 'Henüz takipçi yok',
  thereisnovideos: 'Henüz video yok',
  thereisnophotos: 'Henüz fotoğraf yok',
  thereisnoshorts: 'Henüz short yok',
  thereisnohistory: 'Henüz geçmiş yok',
  thereisnoresults: 'Sonuç yok',
  thereisnopeople: 'Kişi bulunamadı',
  thereisnotags: 'Etiket yok',
  thereisnoimages: 'Fotoğraf yok',
  thereisnonotifications: 'Henüz bildirim yok',
  thereisnomessages: 'Henüz mesaj yok',
  friends: 'Arkadaşlar',
  vist: 'Ziyaret',
  chat: 'Sohbet',
  remove: 'Kaldır',
  searchHere: 'Burada ara',
  messages: 'Mesajlar',
  go: 'Git',
  delete: 'Sil',
  hint: 'İpucu',
  from: 'Kimden',
  date: 'Tarih',
  comments: 'Yorumlar',
  share: 'Paylaş',
  report: 'Bildir',
  follow: 'Takip et',
  followers: 'Takipçiler',
  age: 'Yaş',
  discription: 'Açıklama',
  unfollow: 'Takibi bırak',
  profile: 'Profil',
  preferences: 'Tercihler',
  language: 'Dil',
  country: 'Ülke',
  cardId: 'Kart kimliği',
  security: 'Güvenlik',
  password: 'Şifre',
  saveChanges: 'Kaydet',
  logout: 'Çıkış',
  displayName: 'Ad',
  birthday: 'Doğum günü',
  addPhoto: 'Fotoğraf ekle',
  changePhoto: 'Fotoğrafı değiştir',
  like: 'Beğen',
  dislike: 'Beğenme',
  save: 'Kaydet',
  subscribe: 'Abone ol',
  subscribed: 'Abone',
  rooms: 'Odalar',
  explore: 'Keşfet',
  pickBirthday: 'Doğum gününü seç'
}

const nl = {
  ...en,
  history: 'Geschiedenis',
  longs: 'Lang',
  images: 'Foto’s',
  shorts: 'Shorts',
  movies: 'Muziek',
  all: 'Alles',
  home: 'Home',
  notifications: 'Meldingen',
  shotavideo: 'Maken',
  settings: 'Instellingen',
  watch: 'Kijken',
  search: 'Zoeken',
  email: 'E-mail',
  job: 'Werk',
  hobby: 'Hobby',
  bio: 'Bio',
  following: 'Volgend',
  postion: 'Land',
  thereisnofriends: 'Nog niemand gevolgd',
  thereisnofollowers: 'Nog geen volgers',
  thereisnovideos: 'Nog geen video’s',
  thereisnophotos: 'Nog geen foto’s',
  thereisnoshorts: 'Nog geen shorts',
  thereisnohistory: 'Nog geen geschiedenis',
  thereisnoresults: 'Geen resultaten',
  thereisnopeople: 'Niemand gevonden',
  thereisnotags: 'Geen tags',
  thereisnoimages: 'Geen foto’s',
  thereisnonotifications: 'Nog geen meldingen',
  thereisnomessages: 'Nog geen berichten',
  friends: 'Vrienden',
  vist: 'Bekijk',
  chat: 'Chat',
  remove: 'Verwijderen',
  searchHere: 'Zoek hier',
  messages: 'Berichten',
  go: 'Ga',
  delete: 'Verwijder',
  hint: 'Hint',
  from: 'Van',
  date: 'Datum',
  comments: 'Reacties',
  share: 'Delen',
  report: 'Melden',
  follow: 'Volgen',
  followers: 'Volgers',
  age: 'Leeftijd',
  discription: 'Beschrijving',
  unfollow: 'Ontvolgen',
  profile: 'Profiel',
  preferences: 'Voorkeuren',
  language: 'Taal',
  country: 'Land',
  cardId: 'Kaart-ID',
  security: 'Beveiliging',
  password: 'Wachtwoord',
  saveChanges: 'Opslaan',
  logout: 'Uitloggen',
  displayName: 'Weergavenaam',
  birthday: 'Verjaardag',
  addPhoto: 'Foto toevoegen',
  changePhoto: 'Foto wijzigen',
  like: 'Vind ik leuk',
  dislike: 'Vind ik niet leuk',
  save: 'Opslaan',
  subscribe: 'Abonneren',
  subscribed: 'Geabonneerd',
  rooms: 'Kamers',
  explore: 'Ontdekken',
  pickBirthday: 'Kies je verjaardag'
}

const he = {
  ...en,
  history: 'היסטוריה',
  longs: 'ארוכים',
  images: 'תמונות',
  shorts: 'קצרים',
  movies: 'מוזיקה',
  all: 'הכל',
  home: 'בית',
  notifications: 'התראות',
  shotavideo: 'יצירה',
  settings: 'הגדרות',
  watch: 'צפייה',
  search: 'חיפוש',
  email: 'אימייל',
  job: 'עבודה',
  hobby: 'תחביב',
  bio: 'אודות',
  following: 'עוקב',
  postion: 'מדינה',
  thereisnofriends: 'עדיין אין נעקבים',
  thereisnofollowers: 'עדיין אין עוקבים',
  thereisnovideos: 'עדיין אין סרטונים',
  thereisnophotos: 'עדיין אין תמונות',
  thereisnoshorts: 'עדיין אין שורטים',
  thereisnohistory: 'עדיין אין היסטוריה',
  thereisnoresults: 'אין תוצאות',
  thereisnopeople: 'לא נמצאו אנשים',
  thereisnotags: 'אין תגיות',
  thereisnoimages: 'אין תמונות',
  thereisnonotifications: 'עדיין אין התראות',
  thereisnomessages: 'עדיין אין הודעות',
  friends: 'חברים',
  vist: 'ביקור',
  chat: 'צ׳אט',
  remove: 'הסרה',
  searchHere: 'חפש כאן',
  messages: 'הודעות',
  go: 'עבור',
  delete: 'מחק',
  hint: 'רמז',
  from: 'מאת',
  date: 'תאריך',
  comments: 'תגובות',
  share: 'שיתוף',
  report: 'דיווח',
  follow: 'עקוב',
  followers: 'עוקבים',
  age: 'גיל',
  discription: 'תיאור',
  unfollow: 'הפסק לעקוב',
  profile: 'פרופיל',
  preferences: 'העדפות',
  language: 'שפה',
  country: 'מדינה',
  cardId: 'מזהה כרטיס',
  security: 'אבטחה',
  password: 'סיסמה',
  saveChanges: 'שמור',
  logout: 'התנתק',
  displayName: 'שם תצוגה',
  birthday: 'יום הולדת',
  addPhoto: 'הוסף תמונה',
  changePhoto: 'החלף תמונה',
  like: 'אהבתי',
  dislike: 'לא אהבתי',
  save: 'שמור',
  subscribe: 'הרשמה',
  subscribed: 'מנוי',
  rooms: 'חדרים',
  explore: 'גלה',
  pickBirthday: 'בחרו יום הולדת'
}

const pl = {
  ...en,
  history: 'Historia',
  longs: 'Długie',
  images: 'Zdjęcia',
  shorts: 'Shorts',
  movies: 'Muzyka',
  all: 'Wszystko',
  home: 'Start',
  notifications: 'Alerty',
  shotavideo: 'Utwórz',
  settings: 'Ustawienia',
  watch: 'Oglądaj',
  search: 'Szukaj',
  email: 'E-mail',
  job: 'Praca',
  hobby: 'Hobby',
  bio: 'Bio',
  following: 'Obserwowani',
  postion: 'Kraj',
  thereisnofriends: 'Nie obserwujesz jeszcze nikogo',
  thereisnofollowers: 'Brak obserwujących',
  thereisnovideos: 'Brak filmów',
  thereisnophotos: 'Brak zdjęć',
  thereisnoshorts: 'Brak shortsów',
  thereisnohistory: 'Brak historii',
  thereisnoresults: 'Brak wyników',
  thereisnopeople: 'Nie znaleziono osób',
  thereisnotags: 'Brak tagów',
  thereisnoimages: 'Brak zdjęć',
  thereisnonotifications: 'Brak powiadomień',
  thereisnomessages: 'Brak wiadomości',
  friends: 'Znajomi',
  vist: 'Zobacz',
  chat: 'Czat',
  remove: 'Usuń',
  searchHere: 'Szukaj tutaj',
  messages: 'Wiadomości',
  go: 'Idź',
  delete: 'Usuń',
  hint: 'Wskazówka',
  from: 'Od',
  date: 'Data',
  comments: 'Komentarze',
  share: 'Udostępnij',
  report: 'Zgłoś',
  follow: 'Obserwuj',
  followers: 'Obserwujący',
  age: 'Wiek',
  discription: 'Opis',
  unfollow: 'Przestań obserwować',
  profile: 'Profil',
  preferences: 'Preferencje',
  language: 'Język',
  country: 'Kraj',
  cardId: 'ID karty',
  security: 'Bezpieczeństwo',
  password: 'Hasło',
  saveChanges: 'Zapisz',
  logout: 'Wyloguj',
  displayName: 'Nazwa',
  birthday: 'Urodziny',
  addPhoto: 'Dodaj zdjęcie',
  changePhoto: 'Zmień zdjęcie',
  like: 'Lubię',
  dislike: 'Nie lubię',
  save: 'Zapisz',
  subscribe: 'Subskrybuj',
  subscribed: 'Subskrybujesz',
  rooms: 'Pokoje',
  explore: 'Odkrywaj',
  pickBirthday: 'Wybierz urodziny'
}

const sv = {
  ...en,
  history: 'Historik',
  longs: 'Långa',
  images: 'Foton',
  shorts: 'Shorts',
  movies: 'Musik',
  all: 'Alla',
  home: 'Hem',
  notifications: 'Aviseringar',
  shotavideo: 'Skapa',
  settings: 'Inställningar',
  watch: 'Titta',
  search: 'Sök',
  email: 'E-post',
  job: 'Jobb',
  hobby: 'Hobby',
  bio: 'Bio',
  following: 'Följer',
  postion: 'Land',
  thereisnofriends: 'Följer ingen ännu',
  thereisnofollowers: 'Inga följare ännu',
  thereisnovideos: 'Inga videor ännu',
  thereisnophotos: 'Inga foton ännu',
  thereisnoshorts: 'Inga shorts ännu',
  thereisnohistory: 'Ingen historik ännu',
  thereisnoresults: 'Inga resultat',
  thereisnopeople: 'Inga personer hittades',
  thereisnotags: 'Inga taggar',
  thereisnoimages: 'Inga foton',
  thereisnonotifications: 'Inga aviseringar ännu',
  thereisnomessages: 'Inga meddelanden ännu',
  friends: 'Vänner',
  vist: 'Besök',
  chat: 'Chatt',
  remove: 'Ta bort',
  searchHere: 'Sök här',
  messages: 'Meddelanden',
  go: 'Gå',
  delete: 'Ta bort',
  hint: 'Tips',
  from: 'Från',
  date: 'Datum',
  comments: 'Kommentarer',
  share: 'Dela',
  report: 'Anmäl',
  follow: 'Följ',
  followers: 'Följare',
  age: 'Ålder',
  discription: 'Beskrivning',
  unfollow: 'Avfölj',
  profile: 'Profil',
  preferences: 'Inställningar',
  language: 'Språk',
  country: 'Land',
  cardId: 'Kort-ID',
  security: 'Säkerhet',
  password: 'Lösenord',
  saveChanges: 'Spara',
  logout: 'Logga ut',
  displayName: 'Visningsnamn',
  birthday: 'Födelsedag',
  addPhoto: 'Lägg till foto',
  changePhoto: 'Byt foto',
  like: 'Gilla',
  dislike: 'Ogilla',
  save: 'Spara',
  subscribe: 'Prenumerera',
  subscribed: 'Prenumererar',
  rooms: 'Rum',
  explore: 'Utforska',
  pickBirthday: 'Välj födelsedag'
}

const uk = {
  ...en,
  history: 'Історія',
  longs: 'Довгі',
  images: 'Фото',
  shorts: 'Короткі',
  movies: 'Музика',
  all: 'Усі',
  home: 'Головна',
  notifications: 'Сповіщення',
  shotavideo: 'Створити',
  settings: 'Налаштування',
  watch: 'Дивитися',
  search: 'Пошук',
  email: 'Пошта',
  job: 'Робота',
  hobby: 'Хобі',
  bio: 'Про себе',
  following: 'Підписки',
  postion: 'Країна',
  thereisnofriends: 'Ще немає підписок',
  thereisnofollowers: 'Ще немає підписників',
  thereisnovideos: 'Ще немає відео',
  thereisnophotos: 'Ще немає фото',
  thereisnoshorts: 'Ще немає шортсів',
  thereisnohistory: 'Ще немає історії',
  thereisnoresults: 'Немає результатів',
  thereisnopeople: 'Людей не знайдено',
  thereisnotags: 'Немає тегів',
  thereisnoimages: 'Немає фото',
  thereisnonotifications: 'Ще немає сповіщень',
  thereisnomessages: 'Ще немає повідомлень',
  friends: 'Друзі',
  vist: 'Відкрити',
  chat: 'Чат',
  remove: 'Видалити',
  searchHere: 'Шукати тут',
  messages: 'Повідомлення',
  go: 'Перейти',
  delete: 'Видалити',
  hint: 'Підказка',
  from: 'Від',
  date: 'Дата',
  comments: 'Коментарі',
  share: 'Поділитися',
  report: 'Поскаржитися',
  follow: 'Підписатися',
  followers: 'Підписники',
  age: 'Вік',
  discription: 'Опис',
  unfollow: 'Відписатися',
  profile: 'Профіль',
  preferences: 'Параметри',
  language: 'Мова',
  country: 'Країна',
  cardId: 'ID картки',
  security: 'Безпека',
  password: 'Пароль',
  saveChanges: 'Зберегти',
  logout: 'Вийти',
  displayName: 'Ім’я',
  birthday: 'День народження',
  addPhoto: 'Додати фото',
  changePhoto: 'Змінити фото',
  like: 'Подобається',
  dislike: 'Не подобається',
  save: 'Зберегти',
  subscribe: 'Підписка',
  subscribed: 'Підписано',
  rooms: 'Кімнати',
  explore: 'Огляд',
  pickBirthday: 'Оберіть день народження'
}

const id = {
  ...en,
  history: 'Riwayat',
  longs: 'Panjang',
  images: 'Foto',
  shorts: 'Shorts',
  movies: 'Musik',
  all: 'Semua',
  home: 'Beranda',
  notifications: 'Peringatan',
  shotavideo: 'Buat',
  settings: 'Pengaturan',
  watch: 'Tonton',
  search: 'Cari',
  email: 'Email',
  job: 'Pekerjaan',
  hobby: 'Hobi',
  bio: 'Bio',
  following: 'Mengikuti',
  postion: 'Negara',
  thereisnofriends: 'Belum mengikuti siapa pun',
  thereisnofollowers: 'Belum ada pengikut',
  thereisnovideos: 'Belum ada video',
  thereisnophotos: 'Belum ada foto',
  thereisnoshorts: 'Belum ada shorts',
  thereisnohistory: 'Belum ada riwayat',
  thereisnoresults: 'Tidak ada hasil',
  thereisnopeople: 'Tidak ada orang',
  thereisnotags: 'Tidak ada tag',
  thereisnoimages: 'Tidak ada foto',
  thereisnonotifications: 'Belum ada notifikasi',
  thereisnomessages: 'Belum ada pesan',
  friends: 'Teman',
  vist: 'Kunjungi',
  chat: 'Obrolan',
  remove: 'Hapus',
  searchHere: 'Cari di sini',
  messages: 'Pesan',
  go: 'Buka',
  delete: 'Hapus',
  hint: 'Petunjuk',
  from: 'Dari',
  date: 'Tanggal',
  comments: 'Komentar',
  share: 'Bagikan',
  report: 'Laporkan',
  follow: 'Ikuti',
  followers: 'Pengikut',
  age: 'Usia',
  discription: 'Deskripsi',
  unfollow: 'Berhenti mengikuti',
  profile: 'Profil',
  preferences: 'Preferensi',
  language: 'Bahasa',
  country: 'Negara',
  cardId: 'ID kartu',
  security: 'Keamanan',
  password: 'Kata sandi',
  saveChanges: 'Simpan',
  logout: 'Keluar',
  displayName: 'Nama tampilan',
  birthday: 'Ulang tahun',
  addPhoto: 'Tambah foto',
  changePhoto: 'Ganti foto',
  like: 'Suka',
  dislike: 'Tidak suka',
  save: 'Simpan',
  subscribe: 'Berlangganan',
  subscribed: 'Berlangganan',
  rooms: 'Ruang',
  explore: 'Jelajah',
  pickBirthday: 'Pilih tanggal lahir'
}

const th = {
  ...en,
  history: 'ประวัติ',
  longs: 'ยาว',
  images: 'รูปภาพ',
  shorts: 'ชอร์ต',
  movies: 'เพลง',
  all: 'ทั้งหมด',
  home: 'หน้าแรก',
  notifications: 'การแจ้งเตือน',
  shotavideo: 'สร้าง',
  settings: 'การตั้งค่า',
  watch: 'ดู',
  search: 'ค้นหา',
  email: 'อีเมล',
  job: 'งาน',
  hobby: 'งานอดิเรก',
  bio: 'เกี่ยวกับ',
  following: 'กำลังติดตาม',
  postion: 'ประเทศ',
  thereisnofriends: 'ยังไม่ได้ติดตามใคร',
  thereisnofollowers: 'ยังไม่มีผู้ติดตาม',
  thereisnovideos: 'ยังไม่มีวิดีโอ',
  thereisnophotos: 'ยังไม่มีรูป',
  thereisnoshorts: 'ยังไม่มีชอร์ต',
  thereisnohistory: 'ยังไม่มีประวัติ',
  thereisnoresults: 'ไม่พบผลลัพธ์',
  thereisnopeople: 'ไม่พบผู้คน',
  thereisnotags: 'ไม่มีแท็ก',
  thereisnoimages: 'ไม่มีรูป',
  thereisnonotifications: 'ยังไม่มีการแจ้งเตือน',
  thereisnomessages: 'ยังไม่มีข้อความ',
  friends: 'เพื่อน',
  vist: 'เยี่ยมชม',
  chat: 'แชท',
  remove: 'ลบ',
  searchHere: 'ค้นหาที่นี่',
  messages: 'ข้อความ',
  go: 'ไป',
  delete: 'ลบ',
  hint: 'คำใบ้',
  from: 'จาก',
  date: 'วันที่',
  comments: 'ความคิดเห็น',
  share: 'แชร์',
  report: 'รายงาน',
  follow: 'ติดตาม',
  followers: 'ผู้ติดตาม',
  age: 'อายุ',
  discription: 'คำอธิบาย',
  unfollow: 'เลิกติดตาม',
  profile: 'โปรไฟล์',
  preferences: 'การตั้งค่า',
  language: 'ภาษา',
  country: 'ประเทศ',
  cardId: 'รหัสบัตร',
  security: 'ความปลอดภัย',
  password: 'รหัสผ่าน',
  saveChanges: 'บันทึก',
  logout: 'ออกจากระบบ',
  displayName: 'ชื่อที่แสดง',
  birthday: 'วันเกิด',
  addPhoto: 'เพิ่มรูป',
  changePhoto: 'เปลี่ยนรูป',
  like: 'ถูกใจ',
  dislike: 'ไม่ถูกใจ',
  save: 'บันทึก',
  subscribe: 'สมัคร',
  subscribed: 'สมัครแล้ว',
  rooms: 'ห้อง',
  explore: 'สำรวจ',
  pickBirthday: 'เลือกวันเกิด'
}

export const LANG_PACKS = { en, ru, fr, sp, ar, de, it, pt, zh, ja, ko, hi, tr, nl, he, pl, sv, uk, id, th }

export const htmlLangOf = (code) => (code === 'sp' ? 'es' : (code || 'en'))

export const applyDocumentLang = (code) => {
  if (typeof document === 'undefined') return
  const safe = LANG_PACKS[code] ? code : 'en'
  document.documentElement.lang = htmlLangOf(safe)
  document.documentElement.dir = RTL.has(safe) ? 'rtl' : 'ltr'
}

export const readSavedLang = () => {
  try {
    const code = localStorage.getItem(LANG_KEY) || 'en'
    return LANG_PACKS[code] ? code : 'en'
  } catch (err) {
    return 'en'
  }
}

export const writeSavedLang = (code) => {
  const safe = LANG_PACKS[code] ? code : 'en'
  try { localStorage.setItem(LANG_KEY, safe) } catch (err) {}
  applyDocumentLang(safe)
  return safe
}

export const packFor = (code) => {
  const safe = LANG_PACKS[code] ? code : 'en'
  return { code: safe, lang: LANG_PACKS[safe] }
}
